<template>
	<div class="face_track">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">视频人脸检测与跟踪</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			对视频流的BGR24数据进行人脸检测、跟踪。
			调用该接口前必须成功调用SKFaceVideoTrackInit接口。
			该接口与图片人脸检测接口存在互斥，不可并行调用。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">CFaceStruct** __stdcall SKFaceVideoTrack(unsigned char *pBGR24Data, int &nFaceNum);</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）pBGR24Data：视频帧的BGR倒立数据</p>
        <p class="doc_main_p">（2）nFaceNum: 视频帧中检测到的人脸数量</p>
        
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">
        	数据结构（数组）（返回结构体指针，里面有retCount个FaceStruct结构体）
		</p>
		<test-result-structure></test-result-structure>
		<h3 class="doc_main_h3">示例代码</h3>
        <pre class="doc_main_pre"><code class="doc_main_code">int nFaceNum = 0; 
CFaceStruct **pFacesList = SKFaceVideoTrack((unsigned char*)pBGR24Data, nFaceNum);
for(int nFaceIndex = 0; nFaceIndex < nFaceNum; nFaceIndex++)
{
  CFaceStruct *pFace = pFacesList[nFaceIndex];
  // 处理人脸数据
}</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import TestResultStructure from '../../../../components/testResultStructure';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'test-result-structure':TestResultStructure,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFaceLive-Windows','基础接口','视频人脸检测与跟踪'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.face_track{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfacelivewindows/basics/faceTrack.vue